import React from 'react';
import styled from 'styled-components';
import { Helmet } from 'react-helmet-async';

// Main container with responsive padding and max width
const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
  box-sizing: border-box;
`;

// Title styling with responsive font sizes
const Title = styled.h1`
  font-size: 2.5rem;
  margin-bottom: 20px;
  text-align: center;
    color: #333;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

// Content container
const Content = styled.div`
  font-size: 1.125rem;
  line-height: 1.6;
  color: #333;
`;

// Section for grouping related paragraphs
const Section = styled.section`
  margin-bottom: 40px;

  p {
    margin-bottom: 15px;
    color: #555;
  }
`;

const About = () => {
  return (
    <Container>
      <Helmet>
        <title>About MyCinemaDB — Our Story & Mission</title>
        <meta name="description" content="MyCinemaDB was created to share a love for cinema and build a community of cinephiles. Learn about our mission, values, and the team behind the platform." />
      </Helmet>
      <Title>About Us</Title>
      <Content>
        <Section>
          <p>
            This is MyCinemaDB it was created because I wanted to share my love for Cinema with the world and create a safe space to ignite conversations and connect with other Cinephiles.
            Here you can find information about your favorite movies, actors, and directors and also get a Recommendation for a movie night from our AI Cinephile.
          </p>
          <p>
            MyCinemaDB is founded on the values of innovation, integrity, and community.
          </p>
        </Section>
        <Section>
          <p>
            Our team is passionate about delivering quality products and outstanding customer support.
            We continuously strive to improve our offerings and exceed your expectations.
          </p>
        </Section>
        <Section>
          <p>
            Thank you for visiting our website. We hope you enjoy your experience and please do not hesitate to contact us if you have any questions.
          </p>
        </Section>
      </Content>
    </Container>
  );
};

export default About;
